/** @jsxImportSource @emotion/react */

import { FOOTER_CONTENT_LINKS } from "constants/footer";
import { NavLink } from "react-router-dom";

import FooterSideBarStyle from "./style.index";

const FooterSideBar = () => {
  return (
    <div css={FooterSideBarStyle.wrapper}>
      {FOOTER_CONTENT_LINKS.map((items, index) => (
        <NavLink key={index} to={items.to} css={FooterSideBarStyle.linkItem}>
          {items.name}
        </NavLink>
      ))}
    </div>
  );
};

export default FooterSideBar;
